import { Controller } from "@hotwired/stimulus"
import * as tfEmbed from "@typeform/embed"
import jq from "jquery"

export default class extends Controller {
  static targets = ["alert", "investorPrompt", "investorSelect"]

  start(event) {
    if (this.selectedInvestorId) {
      this.openSurvey(event)
    } else {
      this.investorPromptTarget.classList.remove("hidden")
    }
  }

  get selectedInvestorId() {
    const sel = this.investorSelectTarget,
      idx = sel.selectedIndex,
      opt = sel.options[idx]
    if (opt) {
      return opt.value
    }
  }

  openSurvey(event) {
    const invId = this.selectedInvestorId
    if (invId) {
      const queryString = `inv_id=${invId}`
      const url = `${this.data.get("surveyUrl")}?${queryString}`
      tfEmbed.makePopup(url, {
        mode: "popup",
        autoOpen: true,
        onSubmit: () => {
          const successUrl = this.data.get("successUrl")
          if (successUrl) {
            const xhr = new XMLHttpRequest()
            xhr.open("POST", successUrl)
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8")
            xhr.setRequestHeader("X-CSRF-Token", document.querySelector("meta[name='csrf-token']").content)
            xhr.send(queryString)
          }
          this.alertTarget.classList.add("hidden")
        }
      })
    }
  }
}
